import React from "react";
import { Descriptions } from "antd";
import get from "lodash/get";

export default function PractitionerInformation({ practitioner }) {
  const [name] = practitioner.name;
  const [lastName, secondLastName] = name._family
    ? name._family?.extension.map((ext) => ext.valueString)
    : name.family.split(" ");
  return (
    <Descriptions title="Informante">
      <Descriptions.Item label="Nombre">
        {name.given.join(" ")}
      </Descriptions.Item>
      <Descriptions.Item label="Apellido Paterno">{lastName}</Descriptions.Item>
      <Descriptions.Item label="Apellino Materno">
        {secondLastName}
      </Descriptions.Item>
      <Descriptions.Item label="Especialidad">
        {get(practitioner, "qualification[0].code.text")},{" "}
        {get(practitioner, "qualification[0].issuer.display")}
      </Descriptions.Item>
    </Descriptions>
  );
}
